{
  "search": "Search",
  "completed": "Corporation complete",
  "notCompleted": "Corporation not completed",
  "types": {
    "CORPORATION": "Corporation",
    "LLC": "Limited Liability Company",
    "PARTNERSHIP": "Partnership",
    "SOLE_PROPRIETORSHIP": "Sole Proprietorship"
  },
  "table": {
    "name": "Corporation name",
    "primaryContact": "Primary contact",
    "primaryEmail": "Primary contact email",
    "numberOfAccounts": "# of accounts",
    "completedAt": "Completed at ",
    "totalAssets": "Total assets",
    "organization": "Organization"
  },
  "addModal": {
    "title": "Add new corporation",
    "name": "Name",
    "corporationType": "Corporation Type",
    "corporationCountry": "Country",
    "createARelation": "Create a relation",
    "primaryUser": "Primary User",
    "organization": "Organization",
    "establishedDate": "Date Established"
  },
  "tooltips": {
    "establishedDate": "Date Established",
    "primaryEmail": "Primary contact email",
    "physicalAddress": "Address"
  },
  "tabs": {
    "overview": "Overview",
    "details": "Details",
    "affiliates": "Affiliates",
    "documents": "Documents",
    "statements": "Statements",
    "transfers": "Transfers",
    "ledger": "Ledger",
    "trades": "Trades",
    "notes": "Notes"
  },
  "overview": {
    "totalCorporationAssets": "Total Corporation Assets"
  },
  "details": {
    "accountInformation": "Account Information",
    "fees": "Fees",
    "contactInformation": "Contact Information",
    "name": "Name",
    "esablishedDate": "Established Date",
    "country": "Country",
    "address": "Address",
    "type": "Type",
    "incorporationNumber": "Corporation Number",
    "businessIsMemberOfIiroc": "Business is Member of IIROC",
    "taxNumber": "CRA Business Number",
    "email": "Email",
    "phone": "Phone",
    "feeGrid": "Fee Grid",
    "billingCycle": "Billing Cycle"
  },
  "edit": {
    "accountInformation": "Account Information",
    "fees": "Fees",
    "contactInformation": "Contact Information",
    "name": "Name",
    "establishedDate": "Established Date",
    "country": "Country",
    "physicalAddress": "Address",
    "businessType": "Type",
    "incorporationNumber": "Corporation Number",
    "businessIsMemberOfIiroc": "Business Is Member Of IIROC",
    "taxNumber": "CRA Business Number",
    "feeTierId": "Fee Grid",
    "billingScheduleId": "Billing Cycle",
    "primaryEmail": "Email",
    "phone": "Phone",
    "businessTypeOptions": {
      "CORPORATION": "Corporation",
      "LLC": "Limited Liability Company",
      "PARTNERSHIP": "Partnership",
      "SOLE_PROPRIETORSHIP": "Sole Proprietorship"
    },
    "corporationCountry": "Corporation Country",
    "buttons": {
      "updateContactInformation": "Update corporate Contact information",
      "updateFeesInformation": "Update corporate Fees information",
      "updateAccountInformation": "Update corporate account information"
    },
    "title": "Update Corporate Information"
  }
}
